import {useEffect, useRef} from "react";
import {useIsStudentAppExperience} from "../Hooks/useIsStudentAppExperience";
import {useNavigate} from "../Hooks/useNavigate";
import {Routes} from "../constants";

type UseInboxRedirectOptions = {
    shouldRedirect: boolean;
};

export const useInboxRedirect = ({shouldRedirect}: UseInboxRedirectOptions) => {
    const {hasCommunitiesORInvites, hasUniversityLinks} = useIsStudentAppExperience();
    const {navigate} = useNavigate();
    const hasRedirected = useRef(false);

    useEffect(() => {
        if (!shouldRedirect || hasRedirected.current) {
            return;
        }
        if (hasCommunitiesORInvites) {
            navigate({
                path: Routes.HOME,
            });
        } else if (hasUniversityLinks) {
            navigate({path: Routes.DISCOVER});
        }
        hasRedirected.current = true;
    }, [shouldRedirect, hasCommunitiesORInvites, hasUniversityLinks, navigate]);
};
